import PATHS from '../constants';

function fetchHome() {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    return fetch(PATHS.HOME, {
        method: 'GET',
        dataType: 'json',
        headers,
    });
};

export default fetchHome;